import React from 'react'
import { connect } from 'react-redux'
import auth from '../../common/auth'
import { Translate, getTranslate } from 'react-localize-redux'
import {
	connectQzTray,
	getConnectionStatus
} from '../../common/qz/qzTrayService'
import blockedConnectionImg from '../../assets/images/blockedConnection.png'
import qzTrayImg from '../../assets/images/qzTrayTrayIcon.png'
import AbstractSetupPart from './AbstractSetupPart'

class ConnectionCheck extends AbstractSetupPart {
	constructor(props) {
		super(props)
		this.state = {
			qz: {
				qzTrayConnectionCheck: { status: 'upcoming' }
			}
		}
	}

	componentDidMount() {
		this.props.registerCallback(
			this.processCheck.bind(this),
			this.resetCheck.bind(this)
		)
	}

	processCheck() {
		let newState = this.state
		newState.qz.qzTrayConnectionCheck.status = 'in-progress'
		newState.qz.qzTrayConnectionCheck.message = this.props.translate(
			'stationSetup.controller.ATTEMPT_QZ_CONNECTION'
		)
		this.setState(newState)

		let lastError = getConnectionStatus()
		if (lastError && lastError !== 'OK') {
			this.handleConnectionError(lastError)
		} else {
			return connectQzTray().then(
				function() {
					let newState = this.state
					newState.qz.qzTrayConnectionCheck.status = 'succeeded'
					newState.qz.qzTrayConnectionCheck.message = this.props.translate(
						'stationSetup.controller.QZ_CONNECTION_SUCCESSFUL'
					)
					this.setState(newState)
				}.bind(this),
				this.handleConnectionError.bind(this)
			)
		}
	}

	resetCheck() {
		let newState = this.state
		newState.qz.qzTrayConnectionCheck = {
			status: 'upcoming',
			message: this.props.translate('stationSetup.controller.CHECK_CONNECTION')
		}
		this.setState(newState)
	}

	handleConnectionError(err) {
		let newState = this.state
		const errMsg = this.getErrorMessage(err)
		if (errMsg.match(/connection blocked by client/gi)) {
			newState.qz.qzTrayConnectionCheck.status = 'connection-blocked'
			newState.qz.qzTrayConnectionCheck.message = this.props.translate(
				'stationSetup.controller.QZ_BLOCKED'
			)
		} else {
			newState.qz.qzTrayConnectionCheck.status = 'failed'
			newState.qz.qzTrayConnectionCheck.message = errMsg
		}
		this.setState(newState)
		throw err
	}

	render() {
		return (
			<div
				id="qz-connected"
				className={`panel ${ConnectionCheck.decidePanelClassname(
					this.state.qz.qzTrayConnectionCheck.status
				)}`}
			>
				<div className="panel-heading">
					<span
						className={`glyphicon ${ConnectionCheck.decideGlyphiconClassname(
							this.state.qz.qzTrayConnectionCheck.status
						)}`}
						aria-hidden="true"
					/>
					<span>{this.state.qz.qzTrayConnectionCheck.message}</span>
				</div>
				{this.state.qz.qzTrayConnectionCheck.status ===
					'connection-blocked' && (
					<div className="panel-body">
						<div>
							<p className="lead">
								<Translate id="stationSetup.LEAD_2_1" />
							</p>
							<h4>
								<Translate id="stationSetup.LEAD_2_2" />
							</h4>
							<ol>
								<li>
									<span>
										{this.props.translate('stationSetup.' + ConnectionCheck.getOs() + '_LEAD_2_3', {
											qzTrayUrl: qzTrayImg
										})}
									</span>
								</li>
								<li>
									<span>
										<Translate id="stationSetup.LEAD_2_4" />
									</span>
								</li>
								<li>
									<span>
										<Translate id="stationSetup.LEAD_2_5" />
									</span>
								</li>
								<li>
									<Translate id="stationSetup.RERUN_CHECKS_1" />
									<button
										onClick={this.props.runAllChecks.bind(this)}
										className="btn btn-primary"
									>
										<Translate id="stationSetup.RERUN_CHECKS_2" />
									</button>
								</li>
							</ol>
						</div>
						<div className="media">
							<div className="media-left media-middle">
								<img
									className="media-object"
									src={blockedConnectionImg}
									alt="QZ Site Manager dialog"
								/>
							</div>
						</div>
					</div>
				)}
			</div>
		)
	}
}

export default connect(state => ({
	isLoggedIn: auth.isLoggedIn(),
	translate: getTranslate(state.locale)
}))(ConnectionCheck)



// WEBPACK FOOTER //
// ./src/components/qzSetup/ConnectionCheck.js